<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-50 md-medium-size-100 md-xsmall-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-primary">
                    <div class="card-icon">
                        <md-icon>person</md-icon>
                    </div>
                    <h4 class="title">
                        <span v-text="fullName"></span>
                        <span class="federated-user-text" v-if="isFederatedUser" v-text="'Federated User'"></span>
                    </h4>
                </md-card-header>
                <md-card-content>
                    <md-field>
                        <label>First Name</label>
                        <md-input v-model="firstName" type="text"></md-input>
                    </md-field>
                    <md-field>
                        <label>Last Name</label>
                        <md-input v-model="lastName" type="text"></md-input>
                    </md-field>
                    <md-field>
                        <label>E-mail</label>
                        <md-input v-model="email" type="email"></md-input>
                    </md-field>
                    <md-switch v-model="isActive">Is active</md-switch>
                    <div class="checkbox-section">
                        <md-checkbox v-if="!isFederatedUser"  v-model="forcePasswordChange">Force password reset after login</md-checkbox>
                        <md-checkbox v-if="!isFederatedUser"  v-model="changePassword">Change password</md-checkbox>
                        <md-checkbox v-model="disable2fa">Disable 2FA</md-checkbox>
                    </div>

                    <div v-if="changePassword">
                        <md-field>
                            <label>Password</label>
                            <md-input v-model="password" type="password"></md-input>
                        </md-field>
                        <md-field>
                            <label>Confirm password</label>
                            <md-input v-model="confirmPassword" type="password"></md-input>
                        </md-field>
                    </div>

                    <div class="user-update-actions">
                        <md-button class="md-simple" @click.native="actionCancel">Cancel</md-button>

                        <ButtonGroup>
                            <template v-slot:main-button>
                                <md-button class="md-primary" @click="actionSave(false)">Save
                                </md-button>
                            </template>
                            <template v-slot:content>
                                <md-button class="md-primary" @click="actionSave(true)">Save and reset password
                                </md-button>
                            </template>
                        </ButtonGroup>
                    </div>
                </md-card-content>
            </md-card>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";
    import ButtonGroup from "../../components/ButtonGroup";

    export default {
        name: "UserUpdate",
        components: {ButtonGroup},
        computed: {
            fullName() {
                return this.firstName + ' ' + this.lastName;
            },
            currentUser() {
                return this.authenticatedInitData.user ?? {};
            },
            currentUserId() {
                return this.currentUser.id ?? 0;
            },
            ...mapGetters('app', {
                authenticatedInitData: 'getAuthenticatedInitData',
            })
        },
        data() {
            return {
                firstName: '',
                lastName: '',
                email: '',
                isActive: false,
                changePassword: false,
                password: '',
                confirmPassword: '',
                forcePasswordChange: false,
                disable2fa: false,
                isFederatedUser: false,
            }
        },
        methods: {
            actionSave(sendResetPasswordEmail = false) {
                this.$api.userUpdate({
                    segments: {
                        id: this.$route.params.id,
                    },
                    data: {
                        firstName: this.firstName,
                        lastName: this.lastName,
                        email: this.email,
                        isActive: this.isActive,
                        changePassword: this.changePassword,
                        password: this.password,
                        confirmPassword: this.confirmPassword,
                        sendResetPasswordEmail: sendResetPasswordEmail,
                        forcePasswordChange: this.forcePasswordChange,
                        disable2fa: this.disable2fa,
                    }
                }).then(() => {
                    this.changePassword = false;
                    this.password = '';
                    this.confirmPassword = '';

                    if (this.currentUserId === Number(this.$route.params.id)) {
                        this.$bus.emit('init');
                    }
                });
            },
            actionCancel() {
                this.$router.push(this.$enums.RoutePathEnum.USERS);
            },
            ...mapMutations('app', {
                setTitlePage: 'setTitlePage',
            })
        },
        mounted() {
            this.setTitlePage(this.$t('Edit user'));

            this.$api.userView({
                segments: {
                    id: this.$route.params.id,
                }
            }).then(({data}) => {
                this.firstName = data.firstName ?? '';
                this.lastName = data.lastName ?? '';
                this.email = data.email;
                this.isActive = Boolean(data.isActive);
                this.forcePasswordChange = Boolean(data.forcePasswordChange);
                this.disable2fa = Boolean(data.disable2fa);
                this.isFederatedUser = Boolean(data.isFederatedUser);

            }).catch(() => {
                this.$router.push(this.$enums.RoutePathEnum.DASHBOARD)
            });
        },
        watch: {
            changePassword(value) {
                if (!value) {
                    this.password = '';
                    this.confirmPassword = '';
                }
            },
        }
    }
</script>

<style lang="scss">

    .user-update-actions {
        display: flex;
        justify-content: flex-end;
    }

    .checkbox-section {
        display: flex;
        flex-direction: column;
    }

    .federated-user-text {
        color: #f3944c;
        font-size: 0.8rem;
        margin-left: 0.5rem;
        font-weight: bold !important;
    }

</style>
